import React from 'react';
import L from 'leaflet';
import ReactDOMServer from 'react-dom/server';
import Icon10 from '../ReactIcons/icon10';
import { ICON_ANCHOR, ICON_SIZE } from '.';

const mapIcon10 = L.divIcon({
    html: ReactDOMServer.renderToString(<Icon10 />),
    iconSize: ICON_SIZE,
    iconAnchor: ICON_ANCHOR
});

export default mapIcon10;